export default __webpack_public_path__ + "static/media/gaming.0ad4a358.svg";